module.exports = __webpack_public_path__ + "img/btn_red_resting.68175cff.webp";